export const StatData = {
  subheading: "",
  heading: "A Hands-On, Structured BootCamp",
  description:
    "8 weeks of classroom lessons mixed with real hands-on lab time. You get server hardware, BIOS and RAID setup, Linux, and networking, taught by working data center technicians.",
  stats: [
    {
      key: "Weeks",
      value: "8",
    },
    {
      key: "Lab Sessions",
      value: "12+",
    },
    {
      key: "Core Topics Covered",
      value: "20+",
    },
  ],
};
